import styled from 'styled-components';

export const StyledFooter = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 1 auto;
`;

export const StyledCurrentBid = styled.div`
  padding: 9px 12px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
`;

export const StyledEditProxy = styled.div`
  width: 131px;
`;
